export function copyObject<T>(object: T): T {
    return JSON.parse(JSON.stringify(object));
}

export function fromCamelCaseToSnakeCase<T extends Record<string, any>>(obj: T): Record<string, any> {
    const keys = Object.keys(obj) as Array<keyof T>;
    const notNull: Record<string, any> = {};

    for (const key of keys) {
        if (obj[key] !== null) {
            notNull[key as string] = obj[key];
        }
    }

    const snakeCaseObj: Record<string, any> = {};

    for (const key in notNull) {
        if (Object.prototype.hasOwnProperty.call(notNull, key)) {
            const snakeCaseKey = key.replace(/([A-Z])/g, '_$1').toLowerCase();
            snakeCaseObj[snakeCaseKey] = notNull[key];
        }
    }

    return snakeCaseObj;
}
